<template>
  <div class="header-top">
    <div class="header-name">
      <div class="title">单词速记</div>
      <div class="titleSecond">欢迎来到单词速记3.0教师管理系统</div>
      <div class="user">
        <!-- 判断教师端是否连接 -->
        <div class="lock-box">
          <el-tooltip class="item" effect="dark" content="连接已断开，点击重新连接" placement="top-start" v-show="is_socket==0">
            <el-button type="danger" plain size="mini" @click="reLock()"> <i class="el-icon-refresh"></i> 重新连接</el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="点击重新连接" placement="top-start" v-show="is_socket==1">
            <el-tag type="success"> <i class="el-icon-check"></i> 已连接</el-tag>
          </el-tooltip>
        </div>
        <!-- 小蜜蜂操作引导入口 -->
        <div class="entrance" @click="openBeeGuide">
          <el-tooltip class="item" effect="dark" content="小蜜蜂操作指导" placement="bottom">
            <i class="el-icon-question" style="color:#5186c2;"></i>
          </el-tooltip>
        </div>
        <!-- 显示解锁按钮和锁屏按钮 -->
        <div v-show="class_type==1" class="lock-box">
          <el-tooltip class="item" effect="dark" content="点击解锁" placement="top-start" v-show="this.pmzt+ ''=='false'">
            <i class="el-icon-lock lock" @click="lockChange(1)"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="点击锁屏" placement="top-start" v-show="this.pmzt+ ''=='true'">
            <i class="el-icon-unlock lock" @click="lockChange(0)"></i>
          </el-tooltip>
        </div>
        <el-dropdown @command="returnLogin" :hide-on-click="false">
          <span class="el-dropdown-link">
            {{name}} <i class="el-icon-caret-bottom el-icon--right"></i>
          </span>
          <template>
            <el-dropdown-menu>
              <el-dropdown-item @click="returnLogin()">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { lockChangeApi } from "@/api/teacher"
import { browserUrl } from '@/utils/index.js'
export default {
  components: {
  },
  data() {
    return {
      pmzt: null,
      title: '',
      xm: sessionStorage.getItem('xm'),
      list: [],
      name: '',
      class_type: 0,
      class_id: '',
      is_socket: 0,
      browserUrl:browserUrl, // 退出登陆地址
    }
  },
  watch: {
    '$route.query.class_type': function () {
      console.log(this.$route.query.class_type)
      this.class_type = this.$route.query.class_type;
      this.pmzt = this.$route.query.pmzt;
    },
    '$store.state.is_socket': function () {
      this.is_socket = this.$store.state.is_socket
      console.log(this.$store.state.is_socket)
    },
    '$route.name'(to, from) {
      console.log(to)
      if (this.$route.name == 'classStudent') {
        this.class_type = this.$route.query.class_type;
        this.class_id = this.$route.query.classId;
        this.lx = this.$route.query.lx;
        this.bjmc = this.$route.query.bjmc;
        if (this.class_type == 1) {
          this.pmzt = this.$route.query.pmzt;
        } else {
          this.pmzt = false;
        }
      }
    },
  },
  created() {
    console.log(this.$store.state.is_socket)
    this.is_socket = this.$store.state.is_socket
  },

  mounted() {
    this.name = JSON.parse(sessionStorage.getItem('userInfo')).realname
    console.log(this.$route)
    if (this.$route.name == 'classStudent') {
      this.class_type = this.$route.query.class_type;
      this.class_id = this.$route.query.classId;
      this.lx = this.$route.query.lx;
      this.bjmc = this.$route.query.bjmc;
      if (this.class_type == 1) {
        this.pmzt = this.$route.query.pmzt;
      } else {
        this.pmzt = false;
      }
    }
  },
  methods: {
    // 唤起小蜜蜂操作引导
    openBeeGuide() {
      this.$Bus.$emit('open_bee_guide')
    },
    returnLogin() {
      this.$confirm('是否退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.clear()
        window.location.href = this.browserUrl;
      })
    },
    // 点击重新连接
    reLock() {
      this.$Bus.$emit('reconnect', 1)
    },
    lockChange(type) {
      if (!this.is_socket) {
        this.$message.error('学生平板已掉线，请重新连接')
        return false
      }
      // type 0锁屏 1截屏
      const data = {
        pmzt: type,
        bjid: this.class_id,
        id: this.class_id,
      }
      lockChangeApi(data).then(res => {
        if (res.resultDesc == 'SUCCESS') {
          if (type == 1) {
            // 解锁
            this.pmzt = true
          } else if (type == 0) {
            // 锁屏
            this.pmzt = false
          }
          const query = JSON.parse(JSON.stringify(this.$route.query));
          query.pmzt = this.pmzt
          this.$router.replace({ path: 'classStudent', query: query })
          this.$Bus.$emit('lock_change', { type: type, bjid: this.class_id })
        }
      })
    },

  },

};
</script>

<style scoped="scoped" lang="scss">
.header-top {
  width: 100%;
  height: 70px;
  overflow: hidden;
  // background: #f5f5f5;
  background: #fff;
  .title {
    width: 230px;
    background: #364669;
    height: 70px;
    color: #fff;
    text-align: center;
    font-size: 20px;
    line-height: 70px;
    float: left;
  }
  .titleSecond {
    float: left;
    color: #999;
    text-align: center;
    font-size: 20px;
    line-height: 70px;
    padding-left: 50px;
  }
  .user {
    float: right;
    padding-right: 50px;
    margin-top: 22px;
    display: flex;
    align-items: center;
    .hav {
      font-size: 18px;
      line-height: 70px;
      color: #37474f;
    }
    .lock-box {
      margin-right: 20px;
    }
  }
  .entrance {
    width: 30px;
    height: 30px;
    line-height: 30px;
    margin-right: 10px;
    cursor: pointer;
  }
}
.lock {
  font-size: 24px;
  color: #409eff;
}
.el-icon-unlock {
  color: #67c23a;
}
.el-icon-lock {
  color: #f56c6c;
}
::v-deep .el-icon-question:hover {
  color: #409EFF !important;
}
</style>
